import { InMemoryHeader, InMemoryString } from "pbas-vue-components";
import { i18n } from "@/plugins/i18n";

function getHeaders(languages) {
  const headers = [
    new InMemoryHeader({
      type: new InMemoryString("Identifier"),
      visible: false,
      isIdentifier: true,
      allowVisibilityChange: false,
    }),
    new InMemoryHeader({
      title: "headers.dashboard_items.class_name",
      type: new InMemoryString("Name", {
        getString: (item) => {
          if (item.Name === undefined || item.Name === null) {
            return "";
          }
          return i18n.t("enums." + item.Name);
        },
      }),
      sortable: true,
      visible: true,
      searchable: true,
      allowVisibilityChange: true,
    }),
    new InMemoryHeader({
      title: "views.downloadcenter.icon",
      type: new InMemoryString("Icon", {
        getHtml: (item, type) => {
          return `<i class="v-icon notranslate mdi theme--light ${item.Icon}"></i><span style="margin-left:5px">${item.Icon}</span>`
        },
      }),
      sortable: true,
      visible: true,
      searchable: true,
      allowVisibilityChange: true,
    }),
  ];
  
  for (const lang of languages) {
    headers.push(
      new InMemoryHeader({
        title: i18n.t(`headers.left_drawer_menu_items.title_{0}`, [lang.language.toUpperCase()]),
        type: new InMemoryString(`Title${lang.language.toUpperCase()}`),
        sortable: true,
        visible: true,
        searchable: true,
        allowVisibilityChange: true,
      })
    );
  }

  return headers;
}
export default getHeaders;
